export class PaymentDataRedsys {
    private _endPoint: string;
    private _signatureVersion: string;
    private _merchantParamenters: string;
    private _signature: string;

    constructor(data: any) {
        this._endPoint = data.endPoint;
        this._signatureVersion = data.signatureVersion;
        this._merchantParamenters = data.merchantParamenters;
        this._signature = data.signature;
    }

    public get endPoint() {
        return this._endPoint;
    }
    public get signatureVersion() {
        return this._signatureVersion;
    }
    public get merchantParamenters() {
        return this._merchantParamenters;
    }
    public get signature() {
        return this._signature;
    }
}
